export enum RequiredCriteria {
    all,
    some,
    first,
    primaryFilter,
    none,
}
